export default class CustomError extends Error {
    constructor(message) {
        super(message)

        if ('function' === typeof Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor)
        }
        else {
            this.stack = new Error(message).stack
        }
    }
}

export class AbortError extends Error {}
AbortError.prototype.name = 'AbortError'

export class NetworkError extends CustomError {
    constructor(status, statusText) {
        super(`${status}: ${statusText}`)
        this.status = status
    }
}

NetworkError.prototype.name = 'NetworkError'

export class ServerError extends CustomError {
    constructor({code, detail, message}) {
        super(message)
        this.code = code
        this.detail = detail
    }
}

ServerError.prototype.name = 'ServerError'

export class SuspenseError extends CustomError {}
SuspenseError.prototype.name = 'SuspenseError'
